// src/pages/Dashboard.js
import React, { useState, useEffect, useCallback } from "react";
import { getErrors } from "../api/client";
import StatsCards from "../components/StatsCards";
import ErrorList from "../components/ErrorList";
import { Sparkles } from "lucide-react";

function Dashboard() {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    analyzed: 0,
    fixed: 0,
    avgConfidence: 0,
  });

  const fetchErrors = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getErrors({ limit: 10 });
      setErrors(data.errors || []);

      const total = data.total || 0;
      const analyzed = (data.errors || []).filter(
        (e) => e.has_ai_analysis,
      ).length;
      const fixed = (data.errors || []).filter(
        (e) => e.status === "fixed",
      ).length;

      setStats({
        total,
        analyzed,
        fixed,
        avgConfidence: 85,
      });
    } catch (error) {
      console.error("Error fetching errors:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchErrors();
    const interval = setInterval(fetchErrors, 30000);
    return () => clearInterval(interval);
  }, [fetchErrors]);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent flex items-center gap-2">
          Dashboard
          <Sparkles className="w-4 h-4 text-cyan-400" />
        </h2>
        <p className="text-gray-400">Overview of your application errors</p>
      </div>

      <StatsCards stats={stats} />

      <div className="bg-gradient-to-br from-gray-900/80 to-gray-950/80 backdrop-blur-sm border border-gray-800/50 rounded-xl p-6">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          Recent Errors
          <span className="text-xs text-gray-500 font-normal ml-auto">
            Auto-refreshes every 30s
          </span>
        </h3>
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400"></div>
          </div>
        ) : (
          <ErrorList errors={errors} />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
